<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <v-projects
        :title="$t('shared.list.timers.title')"
        tool="timer"
        :icon="rowIcon"
        :empty="emptyText"
        :badgeText="badgeText"
    />
</template>

<script>
import { markRaw } from "vue";
import moment from "moment";
import vProjects from "@/shared/views/vProjects.vue";
import { TimerIcon } from "@easy/ui/icons";

export default {
    name: "TimerListPage",
    components: { vProjects },
    computed: {
        rowIcon() {
            return markRaw(TimerIcon);
        },
        emptyText() {
            return {
                title: this.$t("shared.list.timers.empty_title"),
                subtitle: this.$t("shared.list.timers.empty_subtitle"),
                ctaLabel: this.$t("shared.list.timers.new"),
            };
        },
    },
    methods: {
        endTime(project) {
            const { value = "en" } = this.lang || {};
            return moment(project.attributes.endDate).locale(value).format("DD/MM/YYYY");
        },
        badgeText(project) {
            return `${this.$t("shared.list.timers.counts_to")} ${this.endTime(project)}`;
        },
    },
};
</script>
